<template>
    <div class="fill-height pa-2">
        <v-card class="fill-height d-flex flex-column" style="max-height: 100%; position: relative; " >
            <v-progress-linear v-if="showLoading" absolute indeterminate></v-progress-linear>
            <v-card-title class="pa-0 ma-0 d-flex align-center">
                <div class="dlg-title-bar flex-grow-1">
                    <div>{{ selectedDevice.name }}</div>
<!--                    TODO Add After Cert-->
<!--                    <div v-if="!selectedDevice.phone" class="caption grey&#45;&#45;text" style="line-height: 1">Last Ping: {{lastPing ? format(lastPing, "yyyy-MM-dd HH:mm:ss") : "None"}}</div>-->
                </div>

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-btn
                                class="mx-1"
                                dark
                                color="blue"
                                icon
                                v-on="on"
                                @click="showTransferOwnership = true"
                        >
                            <v-icon>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </template>
                    Transfer Ownership
                </v-tooltip>
              
              <app-live-view v-if="liveViewDeviceId" :device-id.sync="liveViewDeviceId"></app-live-view>
              
              
              <!-- Compact Icon-Only Live View Button -->
              <app-online-device-wrapper :device-id="selectedDevice._id">
                <template v-slot:default="{employee, device, isOnline, loading, allowLiveView}">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          icon
                          class="mx-1"
                          :color="isOnline && allowLiveView ? 'success' : 'grey'"
                          @click="isOnline && allowLiveView && (liveViewDeviceId = selectedDevice._id)"
                          :disabled="!isOnline || !allowLiveView"
                          v-on="on"
                      >
                        <v-icon :class="{ 'pulse-animation': isOnline && !loading }">
                          {{ isOnline ? 'mdi-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <div class="font-weight-bold">Live View</div>
                      <div class="caption">
                        {{ isOnline ? 'Device Online' : 'Device Offline' }}
                      </div>
                      <div class="caption" v-if="employee && employee.name">
                        {{ employee.name }}
                      </div>
                      <div class="caption" v-if="device && (device.hostname || device.name)">
                        {{ device.hostname || device.name }}
                      </div>
                      <div class="caption mt-1" v-if="!allowLiveView && isOnline">
                        <v-icon x-small color="warning">mdi-alert</v-icon>
                        Screenshots disabled
                      </div>
                    </div>
                  </v-tooltip>
                </template>
              </app-online-device-wrapper>

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-btn
                                icon
                                class="mx-1"
                                color="green"
                                v-on="on"
                                @click="showRenameDevice = true"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    Rename Device
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-btn
                                icon
                                class="mx-1 mr-3"
                                color="red"
                                v-on="on"
                                @click="showDisableDevice = true"
                        >
                            <v-icon>{{selectedDevice.disabled ? 'mdi-lock-off' : 'mdi-lock'}}</v-icon>
                        </v-btn>
                    </template>
                    {{selectedDevice.disabled ? 'Enable Device' : 'Disable Device'}}
                </v-tooltip>

            </v-card-title>
<!--Versions-->
            <app-divider label="Agent Versions" v-if="!selectedDevice.phone && !selectedDevice.o365TenantUser"></app-divider>

            <div class="px-3 my-2 d-flex justify-space-around body-2" v-if="!selectedDevice.phone && !selectedDevice.o365TenantUser">
                <template v-if="latestVersionsLoading">
                    <v-progress-circular :size="28" :width="2" indeterminate color="primary"></v-progress-circular>
                </template>
                <template v-else-if="!latestVersions">
                    <div class="text-center error--text overline">
                        Error Fetching Latest Versions
                    </div>
                </template>

                <template v-else>
                    <v-tooltip
                            v-for="stat in versionInfo"
                            :key="stat.title"
                            top
                    >
                        <template v-slot:activator="{on}">
                            <v-btn
                                    v-on="on"
                                    class="d-flex align-center"
                                    small
                                    text
                                    :color="stat.status === 0 ? 'amber' : (stat.status === 1 ? 'green' : 'error')"
                            >
                                <v-icon v-if="stat.status === 0" color="amber" left>mdi-alert-outline</v-icon>
                                <v-icon v-else-if="stat.status === 1" color="green" left>mdi-check</v-icon>
                                <v-icon v-else-if="stat.status === 2" color="error" left>mdi-alert-outline</v-icon>
                                {{ stat.title }}: {{stat.version || 'N/a'}}
                            </v-btn>
                        </template>
                        {{stat.status === 0 ? 'No Version Info' : (stat.status === 1 ? `Version Up To Date` : `Version Not Up To Date, Latest Version: ${stat.latest}`)}}
                    </v-tooltip>
                </template>
            </div>

<!--Employee-->
            <app-divider label="Device Ownership"></app-divider>

            <div class="d-flex align-center px-3 py-2" style="height: 56px">

                <div v-if="!employee" class="flex-grow-1 d-flex align-center justify-center">
                    <v-icon :color="!employee ? 'error' : null" left>mdi-account</v-icon>
                    <div class="px-3">
                        <div v-if="!employee" class="text-overline error--text text-center" >
                            No Owner Assigned
                        </div>
                        <div v-else>
                            <div class="body-1">{{employee.name}}</div>
                        </div>
                    </div>
                </div>
                <div v-else class="flex-grow-1 px-3" style="cursor: pointer">
                    <v-text-field
                            dense
                            outlined
                            color="primary"
                            :value="employee.name"
                            label="Employee"
                            prepend-inner-icon="mdi-account"
                            readonly
                            hide-details
                            class="pa-0 ma-0"
                            @click="employee ? gotoEmployee(employee._id) : showTransferOwnership = true"
                    />
                </div>

                <div>
                    <v-btn
                            outlined
                            small
                            color="blue"
                            @click="showTransferOwnership = true"
                    >
                        <v-icon left>mdi-swap-horizontal</v-icon>
                        Transfer Ownership
                    </v-btn>
                </div>
            </div>

            <app-divider label="Hardware Info" ></app-divider>
            <div class="px-3 pt-3 flex-grow-1 of-y" v-if="!selectedDevice.phone && !selectedDevice.o365TenantUser">
                <div v-if="!selectedDevice.hwInfo" class="overline error--text text-center">
                    No Hardware Info Collected
                </div>
                <app-device-hardware-info v-else :device="selectedDevice"/>
            </div>
            <div class="px-3 pt-3 flex-grow-1 of-y" v-else-if="selectedDevice.phone">
                <table style="max-width: 400px">
                    <tr>
                        <td class="body-1 pa-2">
                            <v-icon left>mdi-phone</v-icon>
                            Ext:
                        </td>
                        <td class="body-1 font-weight-bold pa-2">
                            {{selectedDevice.username}}
                        </td>
                    </tr>
                    <tr>
                        <td class="body-1 pa-2">
                            <v-icon left>mdi-server</v-icon>
                            Server Type:
                        </td>
                        <td class="body-1 font-weight-bold pa-2">
                            {{selectedDevice.hostname}}
                        </td>
                    </tr>
                </table>

            </div>
          <div class="px-3 pt-3 flex-grow-1 of-y" v-else-if="selectedDevice.o365TenantUser">
            <table style="max-width: 400px">
              <tr>
                <td class="body-1 pr-2">
                  <img width="24px" src="@/assets/teams.svg">
                </td>
                <td class="body-1 font-weight-bold pa-2">
                  Microsoft Teams User
                </td>
              </tr>
            </table>
          
          </div>
<!--Disable-->
            <app-dlg
                    v-if="showDisableDevice"
                    :show-dlg.sync="showDisableDevice"
                    :title="selectedDevice.disabled ? 'Enable Device' : 'Disable Device'"
            >

                <template>
                    Please confirm that you would like to {{selectedDevice.disabled ? 'enable' : 'disable'}} the device {{selectedDevice.name}}
                </template>

                <template v-slot:actions>
                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showDisableDevice = false"
                            outlined
                            size="small"
                            :disabled="disablingDevice"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="disableDevice"
                            small
                            class="ml-2"
                            color="secondary"
                            variant="contained"
                            size="small"
                            :disabled="disablingDevice"
                            :loading="disablingDevice"
                    >
                        Confirm
                    </v-btn>
                </template>
            </app-dlg>
<!--Rename-->
            <app-dlg
                    v-if="showRenameDevice"
                    :show-dlg.sync="showRenameDevice"
                    :model-string.sync="renameDeviceValue"
                    title="Rename Device"
                    show-tf
                    placeholder="eg. Rick Sanchez PC"
                    label="Device Name"
                    class="pa-0 ma-0 mx-2"
                    color="primary"
                    outlined
                    dense
                    :rules="[validationRules.required]"
                    :disabled="renamingDevice"
                    @enter="renameDevice()"
            >
                <template v-slot:actions>
                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showRenameDevice = false"
                            outlined
                            size="small"
                            :disabled="renamingDevice"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="renameDevice"
                            small
                            class="ml-2"
                            color="secondary"
                            variant="contained"
                            size="small"
                            :disabled="!renameDeviceValue || renamingDevice"
                            :loading="renamingDevice"
                    >
                        Rename
                    </v-btn>
                </template>
            </app-dlg>
<!--Transfer Ownership-->
            <app-dlg
                    v-if="showTransferOwnership"
                    :show-dlg.sync="showTransferOwnership"
                    title="Transfer Ownership"
                    :default-padding="false"
                    :add-action-spacer="false"
            >

                <template>
                    <app-list
                            ref="transferOwnershipList"
                            v-model="transferOwnershipSelectedEmployee"
                            :items="availableEmployees"
                            :multiple="false"
                            headline-key="name"
                            item-key="_id"
                            :show-check-boxes="true"
                            :return-object="false"
                            class="fill-height of-y"
                            :height="400"
                            :auto-focus="true"
                    />
                </template>

                <template v-slot:actions>
                    <v-btn
                            class="mr-2"
                            small
                            color="blue"
                            @click="showCreateEmployee = true"
                            outlined
                            size="small"
                            :disabled="transferringOwnership"
                    >
                        Create Employee
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showTransferOwnership = false"
                            outlined
                            size="small"
                            :disabled="transferringOwnership"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="transferOwnership"
                            small
                            class="ml-2"
                            color="secondary"
                            variant="contained"
                            size="small"
                            :disabled="transferringOwnership || !transferOwnershipSelectedEmployee"
                            :loading="transferringOwnership"
                    >
                        Transfer
                    </v-btn>
                </template>
            </app-dlg>
            <app-employee-add v-if="showCreateEmployee" :shown.sync="showCreateEmployee" @input="transferOwnershipSelectedEmployee = $event._id" :show-devices="false"/>
        </v-card>
    </div>
</template>

<script>
import AppDevices from "@/components/Devices/AppDevices";
import {Device} from "@/models/device";
import AppList from "@/components/Shared/AppList/AppList";
import AppDlg from "@/components/Shared/AppDlg";
import {nameSort, validationRules} from "@/core/codeFunctions";
import {mapActions, mapGetters} from "vuex";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import AppDeviceHardwareInfo from "@/components/Devices/AppDeviceHardwareInfo";
import AppEmployeeAdd from "@/components/Employees/AppEmployeeAdd";
import {format} from "date-fns";
import AppLiveView from "@/components/Shared/AppLiveView.vue";
import AppOnlineDeviceWrapper from "@/components/Shared/AppOnlineDeviceWrapper.vue";
export default {
    components: {
      AppOnlineDeviceWrapper,
      AppLiveView, AppEmployeeAdd, AppDeviceHardwareInfo, AppDivider, AppDlg, AppList, AppDevices},
    props: {
        selectedDevice: Device
    },
    data() {
        return {
          liveViewDeviceId: null,
            format: format,
            showCreateEmployee: false,
            showLoading: false,
            fab: false,
            validationRules: validationRules,
            showDisableDevice: false,
            disablingDevice: false,
            showRenameDevice: false,
            renameDeviceValue: null,
            renamingDevice: false,
            showTransferOwnership: false,
            transferOwnershipSelectedEmployee: null,
            transferringOwnership: false,
            latestVersions: null,
            latestVersionsLoading: false,
            vToInt: (value) => {
                const splits = value.split('.')
                while (splits.length < 3)
                    splits.unshift('0')
                splits.forEach((val, i) => {
                    const padAmm = (2 - i)
                    splits[i] = val.padStart(3, '0')
                    for (let k = i; k < padAmm; ++k)
                        splits[i] = splits[i].padEnd(padAmm, '0')
                })
                const val = +splits.reduce((amm, v) => amm + v, 0)
                return val
            }
        }
    },
    watch: {
        showTransferOwnership(val) {
            this.transferOwnershipSelectedEmployee = null;
            this.transferringOwnership = false;
        },
        showRenameDevice(val) {
            if (val) {
                this.renamingDevice = false;
                this.renameDeviceValue = this.selectedDevice.name;
            }
        }
    },
    mounted() {
        this.getLatestVersions()
    },
    methods: {
        ...mapActions(['gotoEmployee']),

        async getLatestVersions() {
            try {
                this.latestVersionsLoading = true;
                this.latestVersions = await this.$newReq('GET', 'latestVersions')
            } catch (e) {
                console.log(e)
            } finally {
                this.latestVersionsLoading = false;
            }
        },

        async transferOwnership() {
            try {
                this.transferringOwnership = true;
                const device = new Device({...this.selectedDevice, employeeId: this.transferOwnershipSelectedEmployee})
                this.selectedDevice.once('update', () => {
                    this.transferringOwnership = false
                    this.showTransferOwnership = false;
                    this.$emit('checkSelected')
                })
                await device.update('employeeId')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
                this.transferringOwnership = false
            }
        },
        async renameDevice() {
            try {
                if (!this.renameDeviceValue)
                    return
                this.renamingDevice = true;
                const device = new Device({...this.selectedDevice, name: this.renameDeviceValue})
                this.selectedDevice.once('update', () => {
                    this.renamingDevice = false
                    this.showRenameDevice = false;
                    this.$emit('checkSelected')
                })
                await device.update('name')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
                this.renamingDevice = false
            }
        },

        async disableDevice() {
            try {
                this.disablingDevice = true;
                const device = new Device({...this.selectedDevice, disabled: !this.selectedDevice.disabled})
                this.selectedDevice.once('update', () => {
                    this.disablingDevice = false
                    this.showDisableDevice = false;
                    this.$emit('checkSelected')
                })
                await device.update('disabled')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
                this.disablingDevice = false
            }
        },
    },
    computed: {
        ...mapGetters(['employeesRef', 'employees', 'employeesWithAccess', 'pingsRef']),

        lastPing() {
            return this.pingsRef[this.selectedDevice._id]?.lastPingDate;
        },

        versionInfo() {
            if (!this.latestVersions)
                return []
            return [
                {
                    title: 'App',
                    version: this.selectedDevice.appVersion || null,
                    latest: this.latestVersions ? this.latestVersions.appVersion : null,
                    status: !this.selectedDevice.appVersion ? 0 : (this.vToInt(this.latestVersions.appVersion) <= this.vToInt(this.selectedDevice.appVersion) ? 1 : 2)
                },
                {
                    title: 'Launcher',
                    version: this.selectedDevice.launcherVersion || null,
                    latest: this.latestVersions ? this.latestVersions.launcherVersion : null,
                    status: !this.selectedDevice.launcherVersion ? 0 : (this.vToInt(this.latestVersions.launcherVersion) <= this.vToInt(this.selectedDevice.launcherVersion) ? 1 : 2)
                },
                {
                    title: 'Update',
                    version: this.selectedDevice.updateVersion || null,
                    latest: this.latestVersions ? this.latestVersions.updateVersion : null,
                    status: !this.selectedDevice.updateVersion ? 0 : (this.vToInt(this.latestVersions.updateVersion) <= this.vToInt(this.selectedDevice.updateVersion) ? 1 : 2)
                },
            ]

        },

        employee() {
            return this.selectedDevice.employeeId && this.employeesRef[this.selectedDevice.employeeId] ? this.employeesRef[this.selectedDevice.employeeId] : null
        },
        availableEmployees() {
            return this.employeesWithAccess.filter((emp) => !emp.disabled).sort(nameSort)
        }
    }

}
</script>

<style scoped>
/* Pulsing animation for online status */
@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.pulse-animation {
  animation: pulse 2s infinite;
}

/* Live view card hover effect */
.live-view-card {
  position: relative;
  overflow: hidden;
  border: 2px solid transparent !important;
  transition: all 0.3s ease !important;
}

.live-view-card:hover {
  transform: translateY(-2px);
  border-color: currentColor !important;
}

/* Add a shimmer effect on hover for online cards */
.live-view-card.success--text:hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shimmer 1s;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>